import {Component, OnDestroy} from '@angular/core';
import {MenuAttachmentModel} from '../../../models/menu-attachment.model';
import {MenuTagModel} from '../../../models/menu-tag.model';
import {Subscription} from 'rxjs';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent, MatDialog} from '@angular/material';
import {ItemService} from '../../../../provider/item.service';
import {CatalogueService} from '../../../../provider/catalogue.service';
import {LanguageTranslatePopup} from '../language-translate/language-translate.popup';
import {MenuItemModel} from '../../../models/menu-item.model';
import {TranslationService} from '../../../../provider/translation.service';
import {MenuSectionService} from '../../../../provider/menu-section.service';
import {AWSService} from '../../../../provider/aws.service';
import {UserService} from '../../../../provider/user.service';
import {TranslateModel} from '../../../../core/_base/layout/models/translate.model';

export class ItemPopupModel {
  Item: MenuItemModel;
  ImageDatas: string[];
  TagDatas: MenuTagModel[];
  files: File[];


  constructor(Item = new MenuItemModel(),
              ImageDatas = [],
              TagDatas = [],
              files = []) {
    this.Item = Item;
    this.ImageDatas = ImageDatas;
    this.TagDatas = TagDatas;
    this.files = files;
  }
}


@Component({
  selector: 'kt-item',
  templateUrl: './item.popup.html',
  styleUrls: ['./item.popup.scss']
})
export class ItemPopup implements OnDestroy {
  data = new ItemPopupModel();
  subs: Subscription[] = [];

  // Tags Start
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes = [ENTER, COMMA];
  currentMenuItemModel: MenuItemModel;

  // Tags End

  constructor(public dialog: MatDialog,
              public itemService: ItemService,
              public myService: CatalogueService,
              public sectionService: MenuSectionService,
              public tra: TranslationService,
              private awsService: AWSService,
              private userService: UserService) {
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  addTags(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const isAvailable = this.data.TagDatas.find(x => x.name == value.trim());
      if (isAvailable == undefined) {
        this.data.TagDatas.push(new MenuTagModel(0, 'menu-item', 0, value.trim()));
      }
    }
    if (input) {
      input.value = '';
    }
  }

  removeTags(i: number) {
    this.data.TagDatas.splice(i, 1);
  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'MenuCategory') {
      this.currentMenuItemModel = baseData;
    } else {
      this.currentMenuItemModel = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      if (this.currentMenuItemModel != undefined) {
        this.data.Item = this.currentMenuItemModel;
      }
    });

  }

  deleteImage(i: number) {
    this.data.ImageDatas.splice(i, 1);
    this.data.files.splice(i, 1);
  }

  imgUploadClick() {
    document.getElementById('file1').click();
  }

  uploadFile(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.data.ImageDatas.push(reader.result.toString());
          this.data.files.push(file);
        };
      }
    }
  }
}
